import { createFileRoute } from '@tanstack/react-router';

import { AiSettingsPage } from '../../../features/ai/ui/settings-page.tsx';
import { requireSettingsPermission } from '../../../lib/permissions.ts';

export const Route = createFileRoute('/_app/settings/ai')({
  // Настройки и журнал ИИ видит только `proposals.manage`; остальным раздел в меню не показывается.
  beforeLoad: requireSettingsPermission('proposals.manage'),
  component: AiSettingsPage,
});
